import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Router } from '@angular/router';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { CartService } from '../../services/cart/cart.service';
import { FormOptionService } from '../../services/cart/form-option/form-option.service';
import { MStepper } from '@argalis-apps/angular-global';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'ags-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit, MStepper.IStepComponent {
  @Input() public step: MStepper.IStep;
  @Output() public backStep = new EventEmitter<any>();
  @Output() public validation = new EventEmitter<any>();
  public currentResa;
  public bConfirm = false;
  public indispo = false;
  public indispoInfo;
  public generatedDocUrl: string;
  public downloadingPrc: boolean;
  public confirmingOrder: boolean;
  public isConfirmedOrder: boolean;
  public creationPrc = false;

  constructor(
    private router: Router,
    private cartConfigService: CartConfigService,
    private cartService: CartService,
    private formOptionService: FormOptionService
  ) {}

  ngOnInit() {
    this.currentResa = this.step.dataInput;
  }

  confirmOrder() {
    if (!this.creationPrc) {
      this.creationPrc = true;
      this.downloadPrc();
    } else {
      this.confirmingOrder = true;
      const validateResa = this.cartService.validateResa(this.currentResa, true);
      const postOption = this.formOptionService.postOptionInfo(
        this.currentResa.id,
        this.currentResa.id_client,
        this.currentResa.formation.optionInfo
      );
      const getEffectif = this.cartService.getEffectif(this.currentResa.selected_session.id);
      const observables = forkJoin([validateResa, postOption, getEffectif]);
      observables.subscribe({
        next: (res: any[]) => {
          // get Effectif
          const currentSession = this.currentResa.selected_session;
          this.isConfirmedOrder = !!res[2].nbPlacesDispo;
          if (!res[2].nbPlacesDispo) {
            this.indispo = true;
            this.indispoInfo = {
              nbPlaces: res[2].nbPlacesDispo,
              currentSession,
              date: moment(currentSession.debut).format('DD-MM-YYYY')
            };
          }
          // Validate Resa
          const validResa = res[0];
          if (validResa && !this.indispo) this.bConfirm = true;
        },
        complete: () => {
          this.confirmingOrder = false;
        }
      });
    }
  }

  downloadPrc() {
    if (this.generatedDocUrl) {
      return window.open(this.generatedDocUrl);
    } else {
      this.downloadingPrc = true;
      this.cartService.createResa(this.currentResa, true).subscribe(
        (validResa: any) => {
          if (validResa) {
            this.cartService.generateDoc(validResa, true).subscribe(
              (data: any) => {
                this.downloadingPrc = false;
                if (data && data.url) {
                  if (!this.generatedDocUrl) this.generatedDocUrl = data.url;
                  window.open(data.url);
                  if (this.creationPrc === true) {
                    this.confirmOrder();
                  }

                  this.creationPrc = true;
                }
              },
              () => {
                this.downloadingPrc = false;
              }
            );
          } else {
            this.downloadingPrc = false;
          }
        },
        () => {
          this.downloadingPrc = false;
        }
      );
    }
    return null;
  }

  async terminateOrder() {
    await this.cartService.getResaList();
    this.router.navigate(['/', `${this.cartConfigService.routingBaseUri}`]);
  }
}
